import React, { useState } from "react";
import { Table } from "antd";

const columns = [
  {
    title: "Bank Date",
    dataIndex: "bank_date",
    key: "bank_date",
  },
  {
    title: "Bank Reference",
    dataIndex: "bank_reference",
    key: "bank_reference",
  },
  {
    title: "Bank Amount",
    dataIndex: "bank_amount",
    key: "bank_amount",
  },
  {
    title: "Ledger Voucher",
    dataIndex: "ledger_voucher",
    key: "ledger_voucher",
  },
  {
    title: "Ledger Date",
    dataIndex: "ledger_date",
    key: "ledger_date",
  },
  {
    title: "Ledger Amount",
    dataIndex: "ledger_amount",
    key: "ledger_amount",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => {
      const statusClass = {
        Matched: "bg-success bg-opacity-10 text-success",
        Unmatched: "bg-danger bg-opacity-10 text-danger",
        "Tolerance Match": "bg-warning bg-opacity-10 text-warning",
      };

      return (
        <span
          className={`badge rounded-pill px-3 py-2 ${statusClass[status]}`}
          style={{ fontSize: "12px" }}
        >
          {status}
        </span>
      );
    },
  },
  {
    title: "Confidence",
    dataIndex: "confidence",
    key: "confidence",
    render: (value) => (
      <div className="d-flex align-items-center gap-2">
        <div
          className="progress"
          style={{ height: "6px", width: "70px", borderRadius: "10px" }}
        >
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${value}%` }}
          ></div>
        </div>
        <span>{value}%</span>
      </div>
    ),
  },
  {
    title: "Actions",
    key: "actions",
    render: (_, record) => {
      if (record.status === "Matched") {
        return (
          <button className="btn btn-light text-danger p-1">Unmatch</button>
        );
      }

      if (record.status === "Unmatched") {
        return <button className="btn btn-primary p-1 px-3">Match</button>;
      }

      return (
        <div className="d-flex gap-2">
          <button className="btn btn-success p-1 px-3">Accept</button>
          <button className="btn btn-light border p-1 px-3">Reject</button>
        </div>
      );
    },
  },
];

const BankReconciliationProcessing = () => {
  const [dataSourcer, setDataSourcer] = useState([
    {
      key: 1,
      bank_date: "2025-01-15",
      bank_reference: "NEFT-123456",
      bank_amount: "₹ 1,50,000",
      ledger_voucher: "RV-2025-001",
      ledger_date: "2025-01-15",
      ledger_amount: "₹ 1,50,000",
      status: "Matched",
      confidence: 100,
    },
    {
      key: 2,
      bank_date: "2025-01-18",
      bank_reference: "CHQ-789012",
      bank_amount: "₹ 2,75,000",
      ledger_voucher: "RV-2025-002",
      ledger_date: "2025-01-18",
      ledger_amount: "₹ 2,75,000",
      status: "Matched",
      confidence: 100,
    },
    {
      key: 3,
      bank_date: "2025-01-18",
      bank_reference: "RTGS-345678",
      bank_amount: "₹ 89,500",
      ledger_voucher: "-",
      ledger_date: "-",
      ledger_amount: "-",
      status: "Unmatched",
      confidence: 0,
    },
    {
      key: 4,
      bank_date: "2025-01-20",
      bank_reference: "IMPS-901234",
      bank_amount: "₹ 45,200",
      ledger_voucher: "RV-2025-004",
      ledger_date: "2025-01-20",
      ledger_amount: "₹ 45,000",
      status: "Tolerance Match",
      confidence: 95,
    },
  ]);

  return (
    <>
      <div className="row g-3">
        {/* Total Transactions */}
        <div className="col-12 col-sm-6 col-md-3">
          <div className="border rounded-4 p-4 text-center bg-white h-100 d-flex flex-column justify-content-center">
            <p className="text-muted mb-1">Total Transactions</p>
            <h4 className="fw-bold mb-1">120</h4>
          </div>
        </div>

        {/* Matched */}
        <div className="col-12 col-sm-6 col-md-3">
          <div className="border rounded-4 p-4 text-center bg-white h-100 d-flex flex-column justify-content-center">
            <p className="text-muted mb-1">Matched</p>
            <h4 className="fw-bold mb-1 text-success">85</h4>
            <small className="text-muted d-block">70.8%</small>
          </div>
        </div>

        {/* Unmatched */}
        <div className="col-12 col-sm-6 col-md-3">
          <div className="border rounded-4 p-4 text-center bg-white h-100 d-flex flex-column justify-content-center">
            <p className="text-muted mb-1">Unmatched</p>
            <h4 className="fw-bold mb-1 text-danger">25</h4>
            <small className="text-muted d-block">20.8%</small>
          </div>
        </div>

        {/* Review Required */}
        <div className="col-12 col-sm-6 col-md-3">
          <div className="border rounded-4 p-4 text-center bg-white h-100 d-flex flex-column justify-content-center">
            <p className="text-muted mb-1">Review Required</p>
            <h4 className="fw-bold mb-1" style={{ color: "#f4a100" }}>
              10
            </h4>
            <small className="text-muted d-block">8.3%</small>
          </div>
        </div>
      </div>

      <div className="border rounded-4 p-2 mt-3 text-center bg-white h-100 d-flex flex-column justify-content-center">
        {/* ACTION BUTTONS */}
        <div className="d-flex flex-wrap gap-2 ">
          <button className="btn btn-primary px-4">
            <i className="fas fa-search me-1"></i> Auto Match
          </button>

          <button className="btn btn-light border px-4">
            <i className="fas fa-undo me-1"></i> Manual Match
          </button>

          <button className="btn btn-light border px-4">
            <i class="fa-solid fa-file-export"></i> Clear Match
          </button>

          <button className="btn btn-danger px-4">
            <i class="fa-solid fa-file"></i> Export Result
          </button>
          <button className="btn btn-danger px-4">
            <i class="fa-solid fa-download"></i> Generate Report
          </button>
        </div>
      </div>

      {/* table */}
      <div className="card p-4 mt-3">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <h5 className="fw-semibold mb-3">Bank Reconciliation Matching</h5>
        </div>
        <div className="table-responsive custom-table query-list-table mt-4">
          <Table
            className="table datanew dataTable no-footer"
            // rowSelection={rowSelection}
            dataSource={dataSourcer}
            columns={columns}
            pagination={false}
            rowClassName={(record) =>
              record.is_priority === "YES" ? "prior-query" : ""
            }
          />
        </div>
      </div>
    </>
  );
};

export default BankReconciliationProcessing;
